<template>
    <div class="cases-card">
        <b-card no-body class="p-3">
            <b-container v-if="current_hub || current_team">
                <b-row>
                    <b-col cols="6" class="border-right">
                        <p class="mb-2">Total Pending Cases (Total Pre-Rev.)</p>
                        <div class="d-flex align-items-center mb-2">
                            <h3 class="font-weight-bold mb-0" v-if="current_hub">
                                {{current_hub.total_cases.pending}} (RM {{ current_hub.team_total_pre_rev | moneyFormatter }})
                            </h3>
                            <h3 class="font-weight-bold mb-0" v-else-if="current_team">
                                {{current_team.team_total_cases.pending}} (RM {{ current_team.team_total_revenue_point | moneyFormatter }})
                            </h3>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 256 256" class="ml-2"><path fill="#0BC196" d="M215.39 163.06A8 8 0 0 1 208 168H48a8 8 0 0 1-5.66-13.66l80-80a8 8 0 0 1 11.32 0l80 80a8 8 0 0 1 1.73 8.72Z"/></svg>
                            <small class="text-success">20%</small>
                        </div>
                        <b-link href="#" class="mb-0 text-primary" @click="modals.show_table = true">View Details</b-link>
                    </b-col>
                    <b-col cols="6">
                        <p class="mb-2">Total Actual Cases (Total RP)</p>
                        <div class="d-flex align-items-center">
                            <h3 class="font-weight-bold mb-0" v-if="current_hub">
                                {{current_hub.total_cases.actual}} (RM {{ current_hub.team_total_actual_rev | moneyFormatter }})
                            </h3>
                            <h3 class="font-weight-bold mb-0" v-else-if="current_team">
                                {{current_team.team_total_cases.actual}} (RM {{ current_team.team_actual_total_revenue_point | moneyFormatter }})
                            </h3>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 256 256" class="ml-2"><path fill="#0BC196" d="M215.39 163.06A8 8 0 0 1 208 168H48a8 8 0 0 1-5.66-13.66l80-80a8 8 0 0 1 11.32 0l80 80a8 8 0 0 1 1.73 8.72Z"/></svg>
                            <small class="text-success">5%</small>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </b-card>
        <TotalPendingCaseTableModal :show_table.sync="modals.show_table" :hub_id="hub_id" :hub_team_id="hub_team_id"/>
    </div>
</template>
<script>
import TotalPendingCaseTableModal from '@/views/Commission/Hub/HubProfile/HubModals/ShowTableModals/TotalPendingCaseTableModal'

export default {
    props: ['current_hub', 'current_team'],
    components: {
        TotalPendingCaseTableModal,
    },
    watch: {
        current_team: {
            immediate: true, // Trigger the watcher immediately
            handler(newCurrentTeam) {
                if (newCurrentTeam) {
                    this.hub_id = newCurrentTeam.hub.hub_id;
                    this.hub_team_id = newCurrentTeam.hub_team_id
                    this.revenue_distribution_settings = newCurrentTeam.hub.revenue_distribution_settings
                }
            },
        },
    },
    data() {
        return {
            modals:{
                show_table: false
            },
            hub_id: null,
            hub_team_id: null,
        }
    },
    created() {
        if(this.$route.params.hub_id)
        {
            this.hub_id = this.$route.params.hub_id
        }
    },
}
</script>